import type { AudioSession } from './types';

export const NAME = 'audio' as const;

export const INITIAL_AUDIO_SESSION = 'playback' as const;
